// src/router/index.ts
import { createRouter, createWebHistory  } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '../stores/auth'

// 뷰(페이지) 컴포넌트를 import
import Login from '@/views/Login.vue'
import MainLayout from '@/views/MainLayout.vue'
import Monitor from '@/views/Monitor.vue'
import Search from '@/views/Search.vue'
import Device from '@/views/Device.vue'
import EventManager from '@/views/EventManager.vue'
import Admin from '@/views/Admin.vue'
import FarmQuery from '@/views/FarmQuery.vue'

//import Device from '@/views/Device.vue'
//import EventList from '@/views/EventList.vue'
//import Admin from '@/views/Admin.vue'

import axios from 'axios'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/login' // 기본 진입 시 /monitor로 리다이렉트
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/farm',
    name: 'FarmQuery',
    component: FarmQuery
  },
  {
    path: '/main',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'monitor',
        name: 'Monitor',
        component: Monitor
      },
      {
        path: 'search',
        name: 'Search',
        component: Search
      },
      {
        path: 'device',
        name: 'device',
        component: Device
      },
      {
        path: 'event',
        name: 'event',
        component: EventManager
      },
      {
        path: 'admin',
        name: 'admin',
        component: Admin
      }
    ]
  },
]

const router = createRouter({
  history: createWebHistory(), // HTML5 히스토리 모드
  routes
})


router.beforeEach(async (to, from, next) => {
  const auth = useAuthStore()

  // /farm 페이지는 로그인 없이 접근 가능
  if (to.path === '/farm') {
    next()
    return
  }

  // 서버에 로그인 상태 확인 요청
  try {
    const response = await axios.get('/api/auth/status', { withCredentials: true })
    auth.setAuthenticated(response.data.loggedIn)  // 상태 업데이트
    console.log("rounter get auth info : ", response.data, to.path, from.path);

    if (!response.data.loggedIn) {
      console.log("rounter /login");
      if (to.path !== '/login') {
        next('/login')  // 로그인 안되어 있는데 로그인 페이지가 아닐 경우만 리디렉션
      } else {
        next()          // 이미 로그인 페이지라면 그냥 진입 허용
      }
    } else {
      if (to.path === '/login') {
        if (from.path === '/main/monitor') {
          next(false)  // 이미 리디렉션된 상태이므로 중지
        } else {
          console.log("rounter gototo /main/monitor");
          next('/main/monitor')  // 로그인된 상태에서 login 접근 시 main으로
        }
      } else {
        next()  // 로그인된 상태이고 로그인 페이지도 아니면 통과
      }
    }
  } catch (error) {
    console.error('인증 확인 실패', error)
    next('/login')
  }
})


export default router
